export enum IframeMessage {
  CLOSE_CHECKOUT = 'appcharge_close_checkout',
  ORDER_CREATED = 'appcharge_order_created',
  ORDER_COMPLETED_FAILED = 'appcharge_order_completed_failed',
  ORDER_COMPLETED_SUCCESS = 'appcharge_order_completed_success',
  ON_PAYMENT_INTENT = 'appcharge_on_payment_intent',
  PAYMENT_INTENT_SUCCESS = 'appcharge_payment_intent_success',
  PAYMENT_INTENT_FAILED = 'appcharge_payment_intent_failed',
  CHECKOUT_OPENED = 'appcharge_checkout_opened',
  APPCHARGE_THEME = 'appcharge_theme',
  CHECKOUT_DIMENSIONS_CHANGED = 'appcharge_checkout_dimensions_changed',
}

export enum InternalMessageEventsName {
  APM_REDIRECT = 'appcharge_apm_redirect',
  APM_REDIRECT_CLOSE = 'appcharge_apm_redirect_close',
}
